import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AdminApiService } from '../../../core/services/admin-api.service';

@Component({
    selector: 'app-admin-login',
    templateUrl: './admin-login.component.html'
})
export class AdminLoginComponent {

    username = '';
    password = '';
    loading = false;
    errorMessage = '';

    constructor(
        private adminApi: AdminApiService,
        private router: Router,
        private route: ActivatedRoute
    ) { }

    login(): void {
        this.errorMessage = '';

        if (!this.username || !this.password) {
            this.errorMessage = 'Username and password are required.';
            return;
        }

        this.loading = true;

        this.adminApi.login(this.username, this.password).subscribe(
            (res) => {
                this.loading = false;

                localStorage.setItem('iosc_admin_token', res.token);
                localStorage.setItem('iosc_admin_user', JSON.stringify(res.user));

                const returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/admin/dashboard';

                this.router.navigateByUrl(returnUrl);
            },
            (error) => {
                console.error(error);
                this.loading = false;
                this.errorMessage = 'Invalid username or password.';
            }
        );
    }
}